import { render } from "./motion-info-card.vue?vue&type=template&id=55449ef8&scoped=true"
import script from "./motion-info-card.vue?vue&type=script&lang=js"
export * from "./motion-info-card.vue?vue&type=script&lang=js"

import "./motion-info-card.vue?vue&type=style&index=0&id=55449ef8&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55449ef8"]])

export default __exports__